export default __webpack_public_path__ + "static/media/just_book.f8d60d54.png";